<div class="page-wrapper" [attr.aria-busy]="isLoading">

  <div class="page-header page-header__row">
    <div class="page-header__title-stack">
      <div class="page-title">
        <svg class="page-title__icon" viewBox="0 0 14 13.0858" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6.64645 1.14645C6.84171 0.951184 7.15829 0.951184 7.35355 1.14645L13.1464 6.93934C13.3417 7.1346 13.6583 7.1346 13.8536 6.93934C14.0488 6.74408 14.0488 6.42749 13.8536 6.23223L8.06066 0.43934C7.47487 -0.146447 6.52513 -0.146446 5.93934 0.43934L0.146447 6.23223C-0.0488155 6.42749 -0.0488155 6.74408 0.146447 6.93934C0.341709 7.1346 0.658291 7.1346 0.853553 6.93934L6.64645 1.14645Z" fill="currentColor"/>
          <path d="M7 2.20711L12.4393 7.64645C12.4592 7.66626 12.4794 7.6854 12.5 7.70388V11.8358C12.5 12.5261 11.9404 13.0858 11.25 13.0858H9C8.72386 13.0858 8.5 12.8619 8.5 12.5858V9.58578C8.5 9.30964 8.27614 9.08578 8 9.08578H6C5.72386 9.08578 5.5 9.30964 5.5 9.58578V12.5858C5.5 12.8619 5.27614 13.0858 5 13.0858H2.75C2.05964 13.0858 1.5 12.5261 1.5 11.8358V7.70388C1.52062 7.6854 1.54085 7.66626 1.56066 7.64645L7 2.20711Z" fill="currentColor"/>
        </svg>
        <h1 class="page-title__text">Overview</h1>
      </div>
      <p class="page-title__sub">{{ greeting }}{{ firstName ? ', ' + firstName : '' }}. Here's how your API usage looks for the {{ rangeLabel().toLowerCase() }}.</p>
    </div>

    @if (overview) {
      <div class="dropdown" (appClickOutside)="closeMenu()">
        <button type="button" class="range-picker" (click)="toggleRangeMenu($event)" [attr.aria-expanded]="rangeMenuOpen" aria-haspopup="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/>
          </svg>
          {{ rangeLabel() }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        @if (rangeMenuOpen) {
          <div class="dropdown__menu">
            @for (opt of rangeOptions; track opt.days) {
              <button
                type="button"
                class="dropdown__item"
                [class.dropdown__item--active]="selectedRangeDays() === opt.days"
                (click)="selectRange(opt.days)"
              >{{ opt.label }}</button>
            }
          </div>
        }
      </div>
    } @else if (!loadFailed) {
      <app-skeleton width="180px" height="36px" radius="4px"></app-skeleton>
    }
  </div>

  @if (!overview && !loadFailed) {

    <!-- Loading state same wrapper classes as the real sections below, so
         nothing shifts size/position once data arrives; only the content
         inside swaps from shimmering bars to real values. -->

    <div class="overview-data" aria-hidden="true">
      <div class="overview-kpi-row">
        <div class="billing-card billing-card--dark">
          <app-skeleton width="90px" height="10px" radius="3px"></app-skeleton>
          <app-skeleton width="150px" height="38px" radius="6px"></app-skeleton>
          <app-skeleton width="72px" height="24px" radius="999px"></app-skeleton>
          <app-skeleton width="110px" height="40px" radius="6px"></app-skeleton>
        </div>
        @for (i of [1,2,3,4]; track i) {
          <div class="stat-tile">
            <app-skeleton width="60%" height="12px"></app-skeleton>
            <app-skeleton width="80px" height="28px" radius="6px"></app-skeleton>
            <app-skeleton width="50px" height="14px"></app-skeleton>
            <app-skeleton width="100%" height="32px" radius="6px"></app-skeleton>
          </div>
        }
      </div>

      <div class="overview-row">
        <div class="api-card">
          <div class="api-card__header">
            <div class="api-card__header-stack">
              <app-skeleton width="160px" height="16px"></app-skeleton>
              <app-skeleton width="220px" height="12px"></app-skeleton>
            </div>
            <app-skeleton width="70px" height="28px" radius="6px"></app-skeleton>
          </div>
          <div class="usage-chart-body">
            <app-skeleton width="100%" height="260px" radius="8px"></app-skeleton>
          </div>
        </div>

        <div class="api-card">
          <div class="api-card__header">
            <div class="api-card__header-stack">
              <app-skeleton width="120px" height="16px"></app-skeleton>
              <app-skeleton width="180px" height="12px"></app-skeleton>
            </div>
          </div>
          <div class="key-list">
            @for (i of [1,2,3,4,5]; track i) {
              <div class="usage-row">
                <app-skeleton width="90px" height="12px"></app-skeleton>
                <app-skeleton width="55%" height="6px" radius="99px"></app-skeleton>
                <app-skeleton width="36px" height="12px"></app-skeleton>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="overview-row overview-row--narrow-first">
        <div class="api-card key-overview-card">
          <div class="api-card__header">
            <div class="key-overview-card__header-left">
              <app-skeleton width="44px" height="44px" radius="10px"></app-skeleton>
              <div class="key-overview-card__header-text">
                <app-skeleton width="100px" height="16px"></app-skeleton>
                <app-skeleton width="160px" height="12px"></app-skeleton>
              </div>
            </div>
          </div>
          <div class="key-overview-card__middle">
            <div class="key-overview-card__body">
              <div class="key-overview-card__col">
                <app-skeleton width="70px" height="10px"></app-skeleton>
                <app-skeleton width="60px" height="40px" radius="6px"></app-skeleton>
              </div>
              <div class="key-overview-card__col-divider"></div>
              <div class="key-overview-card__col">
                <app-skeleton width="120px" height="10px"></app-skeleton>
                <app-skeleton width="100%" height="44px" radius="8px"></app-skeleton>
                <app-skeleton width="90px" height="12px"></app-skeleton>
              </div>
            </div>
            <div class="key-overview-card__actions">
              <app-skeleton width="150px" height="44px" radius="6px"></app-skeleton>
            </div>
          </div>
        </div>

        <div class="api-card">
          <div class="api-card__header">
            <div class="api-card__header-stack">
              <app-skeleton width="130px" height="16px"></app-skeleton>
              <app-skeleton width="220px" height="12px"></app-skeleton>
            </div>
          </div>
          <div class="skeleton-rows">
            @for (i of [1,2,3,4]; track i) {
              <app-skeleton width="100%" height="20px"></app-skeleton>
            }
          </div>
        </div>
      </div>
    </div>

  } @else if (!overview) {

    <div class="api-card api-card--full">
      <div class="error-card" role="alert">
        <span class="error-card__icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14Zm.75-9.75a.75.75 0 10-1.5 0v.5a.75.75 0 001.5 0v-.5ZM7.25 8a.75.75 0 011.5 0v3.25a.75.75 0 01-1.5 0V8Z" fill="currentColor"/>
          </svg>
        </span>
        <p class="error-card__title">We couldn't load your overview</p>
        <p class="error-card__desc">Check your connection and try again. Your keys and balance aren't affected.</p>
        <button class="btn--primary" type="button" (click)="retry()">Retry</button>
      </div>
    </div>

  } @else if (overview; as ov) {

    @if (!ov.setupComplete) {
      @let steps = ov.setupSteps;
      <section class="api-card api-card--full setup-card" aria-labelledby="setup-card-title">
        <div class="api-card__header">
          <div class="api-card__header-stack">
            <h2 class="api-card__title" id="setup-card-title">Get to your first call</h2>
            <span class="api-card__desc">Two steps. This card goes away once they're done.</span>
          </div>
        </div>

        <ol class="setup-steps">
          <li class="setup-step" [class.setup-step--done]="steps.hasKey">
            <span class="setup-step__marker" aria-hidden="true">
              @if (steps.hasKey) { <ng-container *ngTemplateOutlet="check"></ng-container> } @else { 1 }
            </span>
            <div class="setup-step__text">
              <span class="setup-step__title">Create an API key</span>
              <span class="setup-step__desc">Every request is authenticated with one.</span>
            </div>
            @if (steps.hasKey) {
              <span class="setup-step__done">Done</span>
            } @else {
              <a class="btn--primary setup-step__action" routerLink="/api-keys/create">Create key</a>
            }
          </li>

          <li class="setup-step" [class.setup-step--done]="steps.firstCall">
            <span class="setup-step__marker" aria-hidden="true">
              @if (steps.firstCall) { <ng-container *ngTemplateOutlet="check"></ng-container> } @else { 2 }
            </span>
            <div class="setup-step__text">
              <span class="setup-step__title">Make your first call</span>
              <span class="setup-step__desc">Run a query in the Playground or from your code.</span>
            </div>
            @if (steps.firstCall) {
              <span class="setup-step__done">Done</span>
            } @else {
              <a class="setup-step__action" routerLink="/playground"
                 [class.btn--primary]="steps.hasKey" [class.btn--secondary]="!steps.hasKey">Open Playground</a>
            }
          </li>
        </ol>
      </section>

      <ng-template #check>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.5 8.5L6.5 11.5L12.5 4.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </ng-template>
    }

    <div class="overview-data" [class.overview-data--refreshing]="isLoading">
      <div class="overview-kpi-row">
        <app-wallet-summary-card [wallet]="ov.wallet"></app-wallet-summary-card>
        @for (stat of ov.stats; track stat.key) {
          <app-stat-tile [stat]="stat"></app-stat-tile>
        }
      </div>

      <div class="overview-row">
        <app-usage-chart-card [series]="ov.series"></app-usage-chart-card>
        <app-top-endpoints-card [endpoints]="ov.topEndpoints"></app-top-endpoints-card>
      </div>

      <div class="overview-row overview-row--narrow-first">
        <app-api-keys-summary-card [summary]="ov.apiKeys"></app-api-keys-summary-card>
        <app-recent-activity-card [items]="ov.recentActivity"></app-recent-activity-card>
      </div>
    </div>

  }

</div>
